import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      infoDetails: null,
      daftarKasek: false,
      unsurEror: {},
      formulir: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      registrasi: (state) => state.data?.registrasi ?? {},
      peserta_cadangan: (state) => state.data?.peserta_cadangan ?? {},
      instruktur_cadangan: (state) => state.data?.instruktur_cadangan ?? {},
      pa: (state) => state.data?.pelatih_ahli ?? {},
    }),

    master() {
      return this.infoDetails?.m_unsur_psp ?? [];
    },

    instansiKasek() {
      const ptkTugases = this.ptk.ptk_tugases || [];

      return ptkTugases
        .filter((tugas) => {
          return [2, 4].includes(Number(tugas.k_tugas));
        })
        .map((tugas) => {
          return {
            nama: (tugas.sekolah && tugas.sekolah.nama) || '',
            sekolah_id: tugas.sekolah_id,
            k_tugas: tugas.k_tugas || '',
            m_tugas: tugas.m_tugas || {},
            sekolah: tugas.sekolah || {},
          };
        });
    },

    isFspLulus() {
      return this.pa.lulus_tahap >= 3 && this.pa.is_gugur !== 1;
    },
  },
  created() {
    if (this.registrasi.instruktur || this.registrasi.pelatih_ahli) {
      this.daftarInfo('pa').then(({ data }) => {
        this.infoDetails = data;
      });
    }
  },
  methods: {
    ...mapActions('preferensi', ['getPreferensi', 'daftarInfo', 'checkUnsur', 'daftaCadang', 'getDkp', 'saveDkp']),

    onReloadPage() {
      window.location.reload();
    },

    onDaftar() {
      this.onResetUnsurError();
      this.$refs.formDaftar.open();
    },

    onDaftarPaCadang() {
      this.$confirm(
        `<span class="black--text">Anda yakin ingin daftar ulang sebagai Fasilitator Program Sekolah Penggerak Angkatan 2?</span>`,
        `Daftar Fasilitator Cadangan`,
        {
          tipe: 'warning',
          data: '',
        }
      ).then(() => {
        this.daftaCadang({ tipe: 'pa' }).then(() => {
          this.$success('Daftar Fasilitator Cadangan berhasil disimpan');
          this.onReloadPage();
        });
      });
    },

    onResetUnsurError() {
      this.unsurEror = {};
    },

    async onDaftarInfo(params) {
      if (params.peran === 'pa') {
        this.onResetUnsurError();
        const data = await this.checkUnsur(params && params.k_unsur_psp).then(({ data }) => data);
        if (!data.is_syarat) {
          this.unsurEror = data.status_syarat || {};
          return;
        }
      }

      if (params.peran === 'kasek') {
        // if (
        //   this.$getDeepObj(this.preferensi, 'peserta_cadangan') &&
        //   [2].includes(Number(this.$getDeepObj(this.preferensi, 'peserta_cadangan.gelombang')))
        // ) {
        //   this.unsurEror = { kasek_cadangan: true };
        //   return;
        // }
        if (this.registrasi && this.registrasi.tutup_peserta) {
          this.unsurEror = { tutup: this.registrasi.tutup_peserta };
          return;
        }
        if (!(this.instansiKasek && this.instansiKasek.length)) {
          this.unsurEror = { kasek: false };
          return;
        }
      }

      this.$set(this.formulir, 'component', params.peran === 'pa' ? 'FormDaftarInfo' : 'FormDaftarKasek');
      this.$set(this.formulir, 'instansiKasek', this.instansiKasek);
      this.$nextTick(() => {
        this.$refs.formulir.open({ k_unsur_psp: params && params.k_unsur_psp });
        this.$refs.formDaftar.close();
      });
    },

    onFormLapor(params) {
      this.$refs.formulir.close();
      this.$set(this.formulir, 'component', 'FormDaftarLapor');
      this.$set(this.formulir, 'params', params);
      this.$nextTick(() => {
        this.$refs.formulir.open();
      });
    },

    onFormDkp() {
      this.$closeNotif();
      this.$set(this.formulirModal, 'title', `Biodata Tambahan Peserta PKP`);
      this.$set(this.formulirModal, 'component', 'FormDkp');
      this.$set(this.formulirModal, 'initValue', {});
      this.$set(this.formulirModal, 'action', {
        action: 'dkp-peserta-save',
      });
      this.getDkp().then((data) => {
        const ptk = (data && data.ptk) || {};
        const profil = (data && data.profil) || {};
        const peserta = (data && data.peserta) || {};
        const mapels = ((profil && profil.mapel) || []).map((item) => {
          return { mapel: item };
        });
        const kelases = ((profil && profil.kelas) || []).map((item) => {
          return { kelas: item };
        });

        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.modalForm && this.$refs.modalForm.reset();
          this.$set(this.formulirModal, 'initValue', {
            no_wa: (profil && profil.no_wa) || '',
            email_alt: (profil && profil.email_alt) || (ptk && ptk.alt_email) || '',
            email_belajar: (profil && profil.email_belajar) || '',
            hasBelajar: profil && profil.email_belajar ? '1' : '0',
            sinyal_internet: (profil && profil.sinyal_internet) || '',
            jaringan_listrik: (profil && profil.jaringan_listrik) || '',
            mapel: mapels.length ? mapels : [''],
            kelas: kelases.length ? kelases : [''],
            allowMapel: data && data.mapel,
            peran: data && data.peran,
            data: profil && profil.data,
            sebagai:
              peserta && peserta.ptk_id_kasek ? 'Kepala Sekolah' : peserta && peserta.k_mapel_psp ? 'Guru' : 'Pengawas',
          });
        });
      });
    },

    linkDkp() {
      this.$closeNotif();
      this.$router.push({ name: 'pkp-peserta' });
    },

    linkBioFsp() {
      this.$closeNotif();
      this.$router.push({ name: 'biodata-fsp' });
    },

    linkPengimbasan() {
      this.$closeNotif();
      this.$router.push({ name: 'pengimbasan-peserta' });
    },
  },
};
